import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/examine/plan/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/examine/plan/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/examine/plan/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/examine/plan/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/examine/plan/update', params,options);

export const getExamineTopicList = (params, options) =>
  request.get('/api/v4ward/examine/topic/getExamineTopicList', Object.assign({}, options, { params }));

export const getOne = (params, options) =>
  request.get('/api/v4ward/group/detail', Object.assign({}, options, { params }));

export const getPlanTopicIdListByPlanId = (params, options) =>
  request.get('/api/v4ward/examine/plan/topic/getPlanTopicIdListByPlanId', Object.assign({}, options, { params }));

export const getPlanTopicListByPlanId = (params, options) =>
  request.get('/api/v4ward/examine/plan/topic/getPlanTopicListByPlanId', Object.assign({}, options, { params }));

export const generate = (params, options) =>
  request.post('/api/v4ward/examine/report/generate',params,options);

  // 字典
export const getDictionary = (params, options) =>
request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }))

// 获取用户列表-人员选择
export const getProjectUserList = (params, options) =>
request.get('/api/v4ward/user/project-user-list', Object.assign({}, options, { params }));
